import React, { useState, useEffect } from "react";
import axios from "axios";
import { useIsMobile } from "../context/MobileContext";
import { inputStyle, inputStyleInvalid } from "../utils/Scripts";

type CepInputProps = {
  cep: string;
  setCep: (cep: string) => void;
  validate: boolean
};

export const CepInput: React.FC<CepInputProps> = ({
  cep,
  setCep,
  validate
}) => {
  const [display, setDisplay] = useState(formatCEP(cep));
  const isMobile = useIsMobile()

  // Formata o CEP: XX.XXX-XXX
  function formatCEP(raw: string) {
    const d = raw.replace(/\D/g, "").slice(0, 8);
    if (d.length <= 2) return d;
    if (d.length <= 5) return d.slice(0, 2) + "." + d.slice(2);
    return d.slice(0, 2) + "." + d.slice(2, 5) + "-" + d.slice(5);
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 8);
    setCep(onlyDigits);
    setDisplay(formatCEP(onlyDigits));
  }

  function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
    const pasted = e.clipboardData.getData("text");
    const onlyDigits = pasted.replace(/\D/g, "").slice(0, 8);
    e.preventDefault();
    setCep(onlyDigits);
    setDisplay(formatCEP(onlyDigits));
  }

  return (
    <input type='text' id='cep' style={validate?inputStyle(isMobile?'180px':'10vw'):inputStyleInvalid(isMobile?'180px':'10vw')} autoComplete='off'
    onChange={handleChange}
    onPaste={handlePaste}
    value={display}
      maxLength={10} // XX.XXX-XXX
    />
  );
};
